module.exports = __webpack_public_path__ + "static/media/beep.d91f3f47.mp3";